import { TrackingEvent } from '@manakincubber/tiime-tracking';

export const APP_OPEN_IDENTIFIED = 'App Open Identified';

export class AppOpenIdentified implements TrackingEvent {
  readonly name = APP_OPEN_IDENTIFIED;
}
